import React, {Component} from 'react';
import './Laschetism.css';
import logo from './logo.png';

const LaschetRepo: {[index: string]: any; } = {
  quantity: ["ein","zwei","drei","vier","fünf","sechs"],
  duration: ["tägige","wöchige","monatige","fache","malige","hebige"],
  prop: ["harte","softe","optionale","intransparente","alternativlose","unumkehrbare"],
  idiocy: ["Wellenbrecher-","Brücken-","Treppen-","Wende-","Impf-","Ehren-"],
  buzzword: ["Lockdown","Stopp","Maßnahme","Kampagne","Sprint","Matrix"],
  when: ["zum Sommer", "auf Weiteres", "zur Bundestagswahl", "2030", "nach den Abiturprüfungen", "in die Puppen"],
  how: ["sofortigen", "nachhaltigen", "allmählichen", "unausweichlichen", "wirtschaftsschonenden", "willkürlichen"],
  application: ["Senkung","Steigerung","Beendigung","Halbierung","Vernichtung","Beschönigung"],
  sub: ["Infektionszahlen.","privaten Treffen.","Wirtschaftsleistung.","Wahlprognosen.","dritten Welle.","Bundeskanzlerin."]
}

function getLaschetism() {
  let selection = [];
  let article = "eine";
  for (let key in LaschetRepo) { 
    let val = LaschetRepo[key];
    selection.push(val[Math.floor(Math.random() * val.length)])
  }
  if (["Lockdown", "Stopp", "Sprint"].includes(selection[4])) {
    article += "n"
    selection[1] += "n"
    selection[2] += "n"
  }
  selection.splice(5,0,"bis")
  selection.splice(7,0,"zur")
  selection.splice(10,0,"der")
  selection[0] = selection[0] + selection.splice(1,1)
  selection[2] = selection[2] + selection.splice(3,1)
  return "Was wir jetzt brauchen ist " + article + " " + selection.join(" ")
}

class Laschetism extends Component { 
    state = { message: null, logoClassName: "Laschet-logo"}
    render() {
        return (
            <>
                <div className="Laschetism">
                    <img src={logo} className={this.state.logoClassName} alt="logo" />
                    {this.state.message}
                </div>
                <button className="LaschetismButton" onClick={() => this.resetMessage()}>Hit me!</button>
            </>
        );
    }
    resetMessage = () => {
        this.setState(() => ({
            message: null
        }));
        this.setState(() => ({
            logoClassName: "Laschet-logo-anim"
        }));
        setTimeout(() => {
            this.setState(() => ({
                message: getLaschetism()
        }));
        this.setState(() => ({
            logoClassName: "Laschet-logo"
        }));
        }, 2000)
    };
}

export default Laschetism;